(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bliss-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bliss-slideshow')){customElements.define('bliss-slideshow',class extends HTMLElement{connectedCallback(){this.slides=[...this.querySelectorAll('.bliss-slide')];this.index=0;this.handleClick=e=>{const b=e.target.closest('[data-direction]');if(b)this.show(this.index+Number(b.dataset.direction));};this.handleSelect=e=>{const slide=e.target.closest('.bliss-slide');if(slide&&this.contains(slide))this.show(this.slides.indexOf(slide));};this.addEventListener('click',this.handleClick);document.addEventListener('shopify:block:select',this.handleSelect);}disconnectedCallback(){this.removeEventListener('click',this.handleClick);document.removeEventListener('shopify:block:select',this.handleSelect);}show(i){this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>{s.hidden=n!==this.index;s.classList.toggle('is-active',n===this.index)});this.querySelector('[data-position]').textContent=(this.index+1)+' / '+this.slides.length;}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
